export default __webpack_public_path__ + "static/media/Logo_Dommus_Conecta.13d315ab.png";